import { FmlxButton, FmlxCard } from 'fmlx-common-ui';
import React, { useState } from 'react';
import LicenseHeader from '../LicenseHeader';
import LicenseRequest from '../modals/LicenseRequest';
import LicenseActivation from '../modals/LicenseActivation';

function LicenseNotActivated() {
  const [showLicenseRequestModal, setShowLicenseRequestModal] = useState(false);
  const [showLicenseActivationModal, setShowLicneseActivationModal] = useState(false);
  return (
    <div id="licenseviolation-licensenotactivated-wrapper">
      <FmlxCard
        id='licenseviolation-licensenotactivated-card'
        disabled={false}
        draggable={false}
        selectable={false}
        selected={false}
        type=""
        variant={FmlxCard.Variant.OUTLINED}
      >
        <FmlxCard.Body id='licenseviolation-licensenotactivated-card-body'>
          <LicenseHeader />
          <h5 id='licenseviolation-licensenotactivated-label-primary' className="label-primary mb-3">License Activation</h5>
          <div id='licenseviolation-licensenotactivated-text-body' className="body p-5">
            Please activated the license to access Rock Maker software. Or you can choose
            trial license for temporary access Rock Maker software.
          </div>
          <div id='licenseviolation-licensenotactivated-footer' className="licenseViolation_footer py-3">
            <FmlxButton
              id='licenseviolation-licensenotactivated-button-activate'
              label="ACTIVATE"
              onClick={() => setShowLicneseActivationModal(true)}
            />
            <FmlxButton
              id='licenseviolation-licensenotactivated-button-request-license'
              label="REQUEST LICENSE"
              onClick={() => setShowLicenseRequestModal(true)}
            />
          </div>
        </FmlxCard.Body>
      </FmlxCard>
      {showLicenseRequestModal && (
        <LicenseRequest closeModal={() => setShowLicenseRequestModal(false)} />
      )}
      {showLicenseActivationModal && (
        <LicenseActivation closeModal={() => setShowLicneseActivationModal(false)} />
      )}
    </div>
  );
}

export default LicenseNotActivated;
